import React, { useMemo } from 'react';
import { createTheme, ThemeProvider as MUIThemeProvider, CssBaseline } from '@mui/material';
import { useTheme } from '../../context/theme/ThemeContext';

const AppThemeProvider = ({ children }) => {
    const { theme } = useTheme();

    const muiTheme = useMemo(() => {
        const isDark = theme === 'dark';

        return createTheme({
            palette: {
                mode: theme,
                primary: {
                    main: '#65c9b8',
                    contrastText: '#ffffff',
                },
                secondary: {
                    main: isDark ? '#94a3b8' : '#4c6f7a',
                },
                background: {
                    default: isDark ? '#0f172a' : '#f8f9fa',
                    paper: isDark ? '#1e293b' : '#ffffff',
                },
                text: {
                    primary: isDark ? '#e2e8f0' : '#475569',
                    secondary: isDark ? '#94a3b8' : '#64748b',
                },
            },
            shape: {
                borderRadius: 8,
            },
            components: {
                MuiButton: {
                    styleOverrides: {
                        root: {
                            textTransform: 'none',
                            borderRadius: '8px',
                        },
                    },
                },
                MuiPaper: {
                    styleOverrides: {
                        root: {
                            backgroundImage: 'none',
                        },
                    },
                },
            },
        });
    }, [theme]);

    return (
        <MUIThemeProvider theme={muiTheme}>
            <CssBaseline />
            {children}
        </MUIThemeProvider>
    );
};

export default AppThemeProvider;
